import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import {
  Form, Input, Button, Row, Col,
} from 'antd';
import LockIcon from 'material-design-icons/action/svg/production/ic_lock_outline_48px.svg';
import MailIcon from 'material-design-icons/communication/svg/production/ic_mail_outline_48px.svg';

import { requestResetPasswordLink } from '../../actions/account';
import SheetTitle from '../SheetTitle';
import c from './ForgotPassword.less';

const FormItem = Form.Item;
const layout = {
  left: {
    xs: 24,
    md: 7,
  },
  right: {
    xs: 24,
    md: 17,
  },
  offset: {
    xs: {
      offset: 0,
    },
    md: {
      offset: 7,
    },
  },
};

class ForgotPasswordComponent extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    requestResetPasswordLink: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    isEmailSent: false,
  };

  handleReCaptcha = (response) => {
    this.props.form.setFieldsValue({
      validation: response,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });

        this.props.requestResetPasswordLink({ ...values, validation: undefined }, values.validation)
          .then(() => {
            this.setState({
              isEmailSent: true,
              loading: false,
            });
          })
          .catch(() => {
            this.setState({
              loading: false,
            });
          });
      }
    });
  };

  render() {
    const { form: { getFieldDecorator } } = this.props;
    const { isEmailSent } = this.state;

    return (
      <div className={c.container}>
        <Helmet defer={false}>
          <title>Reset Passwords at Mp3Caprice</title>
        </Helmet>
        <SheetTitle title="Reset password" />
        {
          isEmailSent ? (
            <div className={c.successMessage}>
              <div className={c.mailIcon}><MailIcon /></div>
              <p>We have sent you an email with reset password instructions.</p>
              <Link to="/" className={c.okButton}>Ok</Link>
            </div>
          ) : (
            <div className={c.wrapper}>
              <Form onSubmit={this.handleSubmit}>
                <Row>
                  <Col {...layout.left} className={c.label}>Username </Col>
                  <Col {...layout.right}>
                    <FormItem className={c.input} hasFeedback>
                      {getFieldDecorator('userId', {
                        rules: [{
                          required: true, message: 'Please enter your username or email ',
                        }],
                      })(
                        <Input placeholder="Username or Email Address" />,
                      )}
                    </FormItem>
                  </Col>
                </Row>
                <Row>
                  <Col {...layout.offset}>
                    <FormItem className={c.input}>
                      {getFieldDecorator('validation', {
                        rules: [{
                          required: true, message: 'Please confirm that you are a human',
                        }],
                      })(
                        <ReCAPTCHA
                          sitekey={process.env.RECAPTCHA_CLIENT}
                          onChange={this.handleReCaptcha}
                          size="normal"
                        />,
                      )}
                    </FormItem>
                  </Col>
                </Row>
                <Row>
                  <Col {...layout.offset}>
                    <Button type="primary" htmlType="submit" className={c.submit} loading={this.state.loading}>
                      Send reset password
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          )
        }
        <div className={c.lockIcon}><LockIcon /></div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  requestResetPasswordLink,
};

export default withRouter(connect(null, mapDispatchToProps)(Form.create()(ForgotPasswordComponent)));
